// src/hooks/useContainerWidth.js
import api from "../config/axiosConfig";
import { useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { actionType } from "../utils/constant";

const fieldsInitialState = {
  work_order_number: "",
  kd_number: "",
  project_title: "",
  creation_date: "",
  type_of_asset: "",
  build_workshop: "",
  purpose: "",
};

export default function useCreateRFI() {
  const { profile } = useSelector((state) => state.profile);
  const navigate = useNavigate();

  const [isWorkOrderFetched, setIsWorkOrderFetched] = useState(false);
  const [fields, setFields] = useState(fieldsInitialState);
  const [error, setError] = useState({});

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    if (name === "work_order_number") {
      setIsWorkOrderFetched(false);
      setFields(fieldsInitialState);
    }
    setFields((prev) => ({ ...prev, [name]: value }));
  };

  function validateFields(obj, requiredFields = []) {
    const validationResult = {
      isValid: true,
      invalidFields: [],
    };

    // If no requiredFields provided, validate all fields
    const fieldsToValidate =
      requiredFields.length > 0 ? requiredFields : Object.keys(obj);

    for (const fieldName of fieldsToValidate) {
      const value = obj[fieldName];
      let isValid = true;

      if (value === null || value === undefined) {
        isValid = false;
      } else if (typeof value === "string" && value.trim() === "") {
        isValid = false;
      } else if (Array.isArray(value) && value.length === 0) {
        isValid = false;
      } else if (typeof value === "object" && Object.keys(value).length === 0) {
        isValid = false;
      }

      if (!isValid) {
        validationResult.isValid = false;
        validationResult.invalidFields.push(fieldName);
      }
    }

    return validationResult;
  }

  const fetchWorkOrderDetails = async () => {
    try {
      if (!fields?.work_order_number) return;
      const response = await api.get(`/api/airtable/workorder-details`, {
        params: {
          company_id: profile?.company_id,
          work_order_number: fields?.work_order_number,
        },
      });
      setFields((prev) => ({
        ...prev,
        ...response.data.fieldMap,
        creation_date: new Date().toISOString().split("T")[0],
      }));
      setIsWorkOrderFetched(true);

      setError({ ...error, work_order_number: undefined });
    } catch (err) {
      console.log(err.response.data.message);
      setIsWorkOrderFetched(false);
      setError({ ...error, work_order_number: err.response.data.message });
    }
  };

  const handleCreateRFI = async () => {
    try {
      if (!isWorkOrderFetched) {
        setError({
          ...error,
          work_order_number: "Work order details are not fetched",
        });
        return;
      }

      if (!profile?.permissions?.actions?.includes(actionType.rfi_create)) {
        toast.error("You don't have permission to create RFI");
        return;
      }

      const submitabledata = {
        // company_id: profile?.company_id,
        wo_number: fields?.work_order_number,
        kd_number: fields?.kd_number,
        project_title: fields?.project_title,
        creation_date: fields?.creation_date,
        asset_type: fields?.type_of_asset,
        build_workshop: fields?.build_workshop,
        purpose_id: fields?.purpose,
        customer_name: fields?.customer_name,
        // production_coordinator_id: profile?.id,
        // model_id: 2,
        model_name: fields?.model_name.toString() || "SNT",
      };
      const requiredFields = ["wo_number", "purpose_id"];

      const validationResult = validateFields(submitabledata, requiredFields);

      if (!validationResult.isValid) {
        const newErrors = { ...error };

        validationResult.invalidFields.forEach((field) => {
          if (field === "purpose_id")
            newErrors["purpose"] = "Purpose is required";
          else newErrors[field] = "This field is required";
        });
        setError(newErrors);
        return;
      }
      setError({});
      //API Call here for create RFI
      await api.post(`/api/rfi`, submitabledata);
      setFields(fieldsInitialState);
      toast.success("RFI created successfully!");
      navigate("/dashboard");
    } catch (err) {
      console.log(err);
      toast.error(err.response.data.message || "Something went wrong!");
    }
  };

  return {
    fields,
    handleFieldChange,
    fetchWorkOrderDetails,
    error,
    handleCreateRFI,
  };
}
